import ApiBase from 'Services/Api/ApiBase';

class Family extends ApiBase {
    route = '/service-users/family';

    getFamily = (id, params = {}) => this.get('/service-users/service_user_family/family', { id, ...params });
};

export default new Family();
